var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";
import { isUndefined } from "engage-common/utils";
var useStyles = createUseStyles(function (theme) { return ({
    tabContainer: {
        width: "100%",
        display: "flex",
        padding: theme.accessoryPanel.tabs.largeTabSize ? "1px 10px 0" : "0px",
    }
}); });
var Tabs = function (props) {
    var classes = useStyles();
    var childIndex = 0;
    var newChildren = React.Children.map(props.children, function (child) {
        if (!React.isValidElement(child)) {
            return null;
        }
        var selected = childIndex === props.value;
        childIndex += 1;
        return React.cloneElement(child, {
            selected: selected,
            onChange: props.onChange,
            value: childIndex - 1
        });
    });
    return (React.createElement("div", { className: clsx(classes.tabContainer, props.className) }, newChildren));
};
export default Tabs;
var useTabStyles = createUseStyles(function (theme) { return ({
    tab: {
        position: "relative",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flex: 1,
        textTransform: theme.accessoryPanel.tabs.largeTabSize ? "none" : "uppercase",
        fontSize: "0.875rem",
        letterSpacing: "0.03em",
        opacity: 0.7,
        padding: [6, 12],
        minHeight: 36,
        cursor: "pointer",
        transition: "opacity 0.2s",
        "&.selected": {
            opacity: 1,
        },
        "&:after": {
            content: "''",
            position: "absolute",
            width: "100%",
            height: 4,
            backgroundColor: theme.color.primary.main,
            top: "calc(100% - 2px)",
            left: 0,
            transformOrigin: "center bottom",
            transform: "scaleX(0)",
            transition: "transform .2s ease-in-out",
        },
        "&.selected:after": {
            transform: "scaleX(1)"
        }
    },
}); });
export var Tab = function (_a) {
    var label = _a.label, _b = _a.selected, selected = _b === void 0 ? false : _b, value = _a.value, onChange = _a.onChange;
    var classes = useTabStyles();
    var handleClick = function () {
        if (onChange && !isUndefined(value)) {
            onChange(value);
        }
    };
    return (React.createElement("div", { className: clsx(classes.tab, selected && "selected"), onClick: handleClick, "data-qa": "tab", "data-value": label }, label));
};
var useTabPanelStyles = createUseStyles(function (theme) {
    var _a;
    return ({
        tabPanelContainer: {
            paddingTop: 20,
            flex: 1,
            display: "flex",
            flexDirection: "column",
            borderTop: theme.accessoryPanel.leaderboard.removeBackgroundSVG ? "1px solid ".concat((_a = theme.accessoryPanel.textColor) !== null && _a !== void 0 ? _a : "white") : "",
        }
    });
});
export var TabPanel = function (props) {
    var children = props.children, value = props.value, index = props.index, other = __rest(props, ["children", "value", "index"]);
    var hidden = value !== index;
    var classes = useTabPanelStyles();
    return (React.createElement("div", __assign({ role: "tabpanel", hidden: hidden, id: "tabpanel-".concat(index) }, other, { className: clsx(!hidden && classes.tabPanelContainer, !hidden && props.className) }), value === index && children));
};
//# sourceMappingURL=Tabs.js.map